import { MainInfo, WrapperMainInfoProps } from './main-info';
import { connect } from 'react-redux';
import { State, RootAction } from 'store/state';
import { userProfileSelector } from 'store/state/domainData/selectors';
import { setAuthModal, setIsYieldTagModalOpen } from 'store/state/app/actions';
import { Dispatch } from 'redux';
import { AuthenticationModalType } from 'components/authentication/types';
import { AuthModalSource } from 'store/state/app';
import withEvents from 'analytics/withEvents';


const mapStateToProps = (state: State) => ({
  user: userProfileSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onOpenAuthModal: () => dispatch(setAuthModal({ type: AuthenticationModalType.Investors }, { isUserInitiated: true, source: AuthModalSource.PropertyInvestors })),
  openYieldTagModal: (id: string) => dispatch(setIsYieldTagModalOpen(id)),
});

const MainInfoWithEvents = withEvents<WrapperMainInfoProps>(sendEvent => ({
  onInvestorsLinkClick: () => sendEvent('property_investors_form_open', 'property', {
    event: {},
  }),
  sendPriceEstimationClickEvent() {
    sendEvent('property_estimation_click', 'property');
  },
}))(MainInfo);

export default connect(mapStateToProps, mapDispatchToProps)(MainInfoWithEvents);
